// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__HWjkW","title":"ClientCherryInfo_title__1btzT","itemText":"ClientCherryInfo_itemText__2VTOv"};